import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/gatsby-theme-axii/src/templates/page/index.tsx";
import ArticleListPage from "../../../src/components/ArticleList";
import { GatsbySeo } from "gatsby-plugin-next-seo";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <GatsbySeo title="Blog - all articles" mdxType="GatsbySeo" />
    <ArticleListPage mdxType="ArticleListPage" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      